import { PromotionListClient } from 'types';
import { ProductCarousel } from 'components/ProductCarousel';
import { useFetchProducts } from 'reactQuery/queries';
import { LoadingSpinner } from 'components/core';
import { Styled } from 'components/ContentfulHomePage';

const ContentfulProductCarousel = ({
  title,
  promotionList,
  skus,
}: {
  title: string;
  promotionList?: PromotionListClient;
  skus: string[];
}) => {
  const {
    data: products,
    isLoading,
    isError,
  } = useFetchProducts({
    skus: skus,
  });
  if (isLoading) {
    return (
      <Styled.LoadingWrapper>
        <LoadingSpinner />
      </Styled.LoadingWrapper>
    );
  }
  return (
    <ProductCarousel
      title={title}
      products={products?.pages[0]?.products ?? []}
      isLoading={isLoading}
      isError={isError}
      doctorPromotionList={promotionList}
    />
  );
};

export default ContentfulProductCarousel;
